// extracted by mini-css-extract-plugin
export default {"imprimirComponent":"ImprimirPantallaComponent_imprimirComponent__aMhZC"};